import { IntlShape } from 'react-intl';

export const getModalHeading = (formatMessage: IntlShape['formatMessage']) =>
  formatMessage({ id: 'receipt' });
